import React, { useEffect, useRef, useState } from 'react';
import clsx from 'clsx';
import styles from './UIGameDiceGroup.module.scss';
import { UIGameDice } from './UIGameDice/UIGameDice.tsx';
import { TurnState } from '@colonist/game-states';
import { UIGameFloatingText } from '../UIGameFloatingText/index.ts';
import { playDiceSound } from './UIGameDiceSounds.ts';
import { UIGameDiceProb } from './UIGameDiceProb/index.ts';
import { useGameStore } from '../../store/GameStoreContext.ts';
const CLOSE_DICE_HELPER_TIMEOUT = 1500;
const RISE_DICE_HELPER_ANIMATION_TIMEOUT = 500;
export function UIGameDiceGroup({ size = 'medium', className, onClick, active, visible, helperText, enableDiceHelper, diceState, eventDiceState, isMyTurn, disableDiceSound, onDiceHelperAnimationEnd }) {
    const isEventDiceActive = eventDiceState !== undefined;
    const isInitialRender = useRef(true);
    const totalDiceNumber = diceState.dice1 + diceState.dice2;
    const [shouldShowDiceHelper, setShouldShowDiceHelper] = useState(false);
    const currentState = useGameStore((state)=>state.gameState.currentState);
    const isSpecialBuildPhase = currentState.turnState == TurnState.SpecialBuildPhase;
    const playDiceHelperAnimation = ()=>{
        if (!enableDiceHelper) return;
        if (!diceState.diceThrown) return;
        setShouldShowDiceHelper(true);
        setTimeout(()=>{
            onDiceHelperAnimationEnd === null || onDiceHelperAnimationEnd === void 0 ? void 0 : onDiceHelperAnimationEnd(totalDiceNumber);
        }, RISE_DICE_HELPER_ANIMATION_TIMEOUT);
        setTimeout(()=>{
            setShouldShowDiceHelper(false);
        }, CLOSE_DICE_HELPER_TIMEOUT);
    };
    const handlePlayDiceSound = ()=>{
        if (disableDiceSound) return;
        if (!diceState.diceThrown) return;
        if (isSpecialBuildPhase) return;
        if (isInitialRender.current) return;
        playDiceSound(totalDiceNumber, isMyTurn);
    };
    useEffect(()=>{
        if (isInitialRender.current) {
            isInitialRender.current = false;
            return;
        }
        handlePlayDiceSound();
        playDiceHelperAnimation();
    }, [
        diceState,
        isMyTurn
    ]);
    const probabilityComponent = /*#__PURE__*/ React.createElement(UIGameDiceProb, {
        className: styles.probWrapper,
        value: totalDiceNumber
    });
    const diceComponent = /*#__PURE__*/ React.createElement(React.Fragment, null, isEventDiceActive && /*#__PURE__*/ React.createElement(UIGameDice, {
        active: active,
        className: clsx(styles.diceWrapper, styles.eventDice),
        onClick: ()=>{
            onClick();
        },
        type: "event",
        value: eventDiceState.eventDice
    }), /*#__PURE__*/ React.createElement(UIGameDice, {
        active: active,
        className: styles.diceWrapper,
        onClick: ()=>{
            onClick();
        },
        type: isEventDiceActive ? 'standardRed' : 'standardWhite',
        value: diceState.dice1
    }), /*#__PURE__*/ React.createElement(UIGameDice, {
        active: active,
        className: styles.diceWrapper,
        onClick: ()=>{
            onClick();
        },
        type: "standardWhite",
        value: diceState.dice2
    }));
    const containerClassName = clsx(styles.container, {
        [styles.hidden]: !visible,
        [styles.large]: size === 'large',
        [styles.medium]: size === 'medium'
    }, className);
    if (helperText) {
        return /*#__PURE__*/ React.createElement(UIGameFloatingText, {
            direction: "up",
            text: helperText,
            className: containerClassName
        }, shouldShowDiceHelper && probabilityComponent, diceComponent);
    }
    return /*#__PURE__*/ React.createElement("div", {
        className: containerClassName,
        id: "roll-dice-button"
    }, shouldShowDiceHelper && probabilityComponent, diceComponent);
}
